import { BaseIRemoteBloc } from "./bloc.base"

export class BoxIRemoteBloc extends BaseIRemoteBloc {

}

